import { combineReducers } from 'redux';
import { SHARE_SPY_ROLE } from '../actions/action-types';

const initialSpyRoleViewState = {};

const spyRoleViewState = (state = initialSpyRoleViewState, action) => {
  switch (action.type) {
    case SHARE_SPY_ROLE:
      // falls through
    default:
      return state;
  }
};

export default combineReducers({ spyRoleViewState });
